export enum DataExchangeRequestStatusDto {
  Open = 0,
  InProgress = 1,
  Submitted = 2,
  ReOpened = 3,
  Closed = 4,
  Deleted = 5
}
